module.exports = __webpack_public_path__ + "img/235-b08902.png";